module.exports = __webpack_public_path__ + "img/female-condom.7e608e18.png";